<template>
	<div id="dialog-assets">
		<el-dialog
			:title="assetForm.title"
			:visible.sync="isShow"
			:show-close="false"
			:close-on-click-modal="false"
			top="4vh"
			class="default-dialog asset-dialog">
			<el-form ref="form" :model="form" :rules="rulesForm" label-width="120px">
				<el-row>
					<div class="h5">资产信息</div>
					<el-col :span="12">
						<el-form-item label="资产编码：" prop="assetsCode">
							<el-input
								size="mini"
								v-model="form.assetsCode">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="资产名称：" prop="assetsName">
							<el-input
								size="mini"
								placeholder="请输入名称"
								v-model="form.assetsName">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="资产类别：" prop="assetsGenresId">
							<el-select
								size="mini"
								default-first-option
								filterable
								placeholder="请选择类别"
								v-model="form.assetsGenresId"
								@change="handlerAssetsNameChange">
								<el-option
									v-for="item in options.assetsGenres"
									:key="item.id"
							    	:label="item.genresName"
							    	:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="录入时间：">
							<el-input
								size="mini"
								disabled
								placeholder="录入时间"
								v-model="form.entryTime">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="使用部门：" prop="departName">
							<el-select
								size="mini"
								filterable
								placeholder="请选择部门"
								v-model="form.departName"
								class="departName-input">
								<el-option
									v-for="item in options.departName"
									:key="item.id"
							    	:label="item.name"
							    	:value="item.name">
								</el-option>
							</el-select>
							<a href="javascript:;" class="setDefault" @click="addDepartment">新增</a>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始日期：" prop="startUse">
							<el-date-picker
								v-model="form.startUse"
								size="mini"
								placeholder="请选择开始日期"
								:default-value="entryTime"
								:picker-options="pickerOptions.startUse"
								@change="handlerStartUseChange">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
						<el-form-item label="清理期间：">
							<el-input
								size="mini"
								disabled
								v-model="form.clearPeriod">
							</el-input>
						</el-form-item>
					</el-col> -->
					<el-col :span="12">
						<el-form-item label="购买凭证：">
							<a href="javascript:;" v-if="form.adds.id" v-text="form.adds.name" @click='handleJump_PZ(form.adds)'></a>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 折旧方式 start -->
				<el-row>
					<div class="h5">折旧方式</div>
					<el-col :span="12">
						<el-form-item label="折旧方式：" prop="zhejiuStyle">
							<el-select
								size="mini"
								placeholder="请选择"
								v-model="form.zhejiuStyle">
							    <el-option
							    	v-for="item in options.zhejiuStyle"
							    	:key="item.value"
							    	:label="item.label"
							    	:value="item.value">
							    </el-option>
						  	</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="预计使用期数：" class="expectYear" prop="expectYear">
							<el-input
								size="mini"
								placeholder="请输入名称"
                @blur="commonCalculation"
								v-model="form.expectYear">
							</el-input>
							<span>期</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="固定资产科目：" prop="fixationSubjectId">
							<el-select
								size="mini"
								placeholder="请选择"
								filterable
								v-model="form.fixationSubjectId">
							    <el-option
							    	v-for="item in subjectData"
							    	:key="item.id"
							    	:label="item.labels"
							    	:value="item.id">
							    </el-option>
						  	</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="累计折旧科目：" prop="depreciationSubjectId">
							<el-select
								size="mini"
								placeholder="请选择"
								filterable
								v-model="form.depreciationSubjectId">
							    <el-option
							    	v-for="item in subjectData"
							    	:key="item.id"
							    	:label="item.labels"
							    	:value="item.id">
							    </el-option>
						  	</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="折旧费用科目：" class="apportionSubject" prop="apportionSubjectId">
							<el-select
								size="mini"
								placeholder="请选择"
								filterable
								v-model="form.apportionSubjectId">
							    <el-option
							    	v-for="item in subjectData"
							    	:key="item.id"
							    	:label="item.labels"
							    	:value="item.id">
							    </el-option>
						  	</el-select>
							<a href="javascript:;" class="setDefault" @click="setDefault(form.apportionSubjectId)">默认</a>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="支付方式科目：" prop="paySubjectId">
							<el-select
								size="mini"
								placeholder="请选择"
								filterable
								v-model="form.paySubjectId">
							    <el-option
							    	v-for="item in subjectData"
							    	:key="item.id"
							    	:label="item.labels"
							    	:value="item.id">
							    </el-option>
						  	</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 原值、净值、累计折旧 start -->
				<el-row>
					<div class="h5">原值、净值、累计折旧</div>
					<el-col :span="12">
						<el-form-item label="原值：" prop="resourceAssets">
							<el-input
								size="mini"

								placeholder="请输入原值"
								v-model="form.resourceAssets"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'resourceAssets')">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item class="residualRatio" label="残值率：">
							<el-input
								size="mini"
								placeholder="请输入残值率"
								v-model="form.residualRatio"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'residualRatio')">
							</el-input>
							<span>%</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="减值准备：" prop="depreciationReserves">
							<el-input
								size="mini"
								placeholder="请输入减值"
								v-model="form.depreciationReserves"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'depreciationReserves')">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="预计残值：">
							<el-input
								size="mini"
								disabled
								v-model="salvage">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="期初累计折旧：" prop="beginningDepreciation">
							<el-input
								size="mini"
								placeholder="请输入期初累计折旧"
								v-model="form.beginningDepreciation"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'beginningDepreciation')">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="已折旧期数：" class="expectYear" prop="depreciationPeriod">
							<el-input
								size="mini"
								placeholder="请输入已折旧期间"
								v-model="form.depreciationPeriod"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'depreciationPeriod')">
							</el-input>
							<span>期</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="月折旧：">
							<el-input
								size="mini"
								:disabled="true"
								placeholder="请输入月折旧"
								v-model="form.monthdepreciation"
								@focus="handleEditField"
								@blur="handleCancelEdit($event, 'monthdepreciation')">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="期初净值：">
							<el-input
								size="mini"
								disabled
								v-model="beginningNetvalue">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注：">
							<el-input
								type="textarea"
								:rows="5"
								v-model="form.remarks">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<span v-if="assetForm.status == 'add'" class="isTextred">是否生成固定资产凭证？</span>
		    	<el-button
		    		size="small"
		    		class="mg-button-cancel"
		    		@click="isShow = false">
		    		取 消
		    	</el-button>
		    	<el-button
		    		v-if="isButtonShow"
		    		size="small"
		    		class='minButton'
		    		:disabled="isDisabled"
		    		@click="confirm('form', 1)">
		    		生成购买凭证并保存
		    	</el-button>
			    <el-button
			    	size="small"
			    	class='minButton'
			    	:disabled="isDisabled"
			    	@click="confirm('form', 2)">
			    	仅保存
			    </el-button>
		  	</span>
		</el-dialog>

		<!-- 新增部门 -->
		<add-department-dialog
			:showVisible.sync="isShowAddDepartmentDialog"
			@isShowAddDepartmentDialog = "handleIsShowAddDepartmentDialog"
			@onRefresh="refreshDepartmentData">
		</add-department-dialog>
		<!-- 修改凭证  -->
		<edit-voucher :visible.sync="XG_voucherShow" :row="rows"
			@on-close-dialog="cancel" @on-success-submit="successEdit"
			v-if="XG_voucherShow">
		</edit-voucher>
	</div>
</template>

<script>
import AddDepartmentDialog from '@/components/dialog/AddDepartmentDialog'
import editVoucher from '@/components/table/editVoucher'
export default {
	components: {
		AddDepartmentDialog,
		editVoucher
	},
	props: {
		showVisible: Boolean,
		tableData:String,
		assetForm: {
			type: Object,
			default () {
				return {
					data: {
						cid: '',
						id: '',
						assetsCode: '',
						assetsName: '',
						assetsGenresId: '',
						entryTime: '',
						entryTimeStamp: '',
						departName: '',
						startUse: '',
						clearPeriod: '',
						zhejiuStyle: '1',
						expectYear: 0,
						fixationSubjectId: '',
						depreciationSubjectId: '',
						apportionSubjectId: '',
						paySubjectId: '',
						resourceAssets: 0,
						residualRatio: 0,
						depreciationReserves: 0,
						beginningNetvalue: 0,
						monthdepreciation: 0,
						depreciationPeriod: 0,
						beginningDepreciation: 0,
						salvage: 0,
						remarks: '',
						yearPeriods: '',
						adds: {
							name: '',
							id: ''
						},
					},
					title: '新增资产类别',

				}
			}
		},
	},
	data () {
		const expectYears = (rule , value , callback) =>{
			let reg = /^[0-9]*[1-9][0-9]*$/
			if (!reg.test(value)) {
				return callback(new Error('只能输入正整数'))
			}
			callback();
		}
		const validateResourceAssets = (rule, value, callback) => {
			if (value === '' || value == 0 || !value) {
				return callback(new Error('请输入原值'))
			}
			callback();
		}
		const validateBeginningDepreciation = (rule, value, callback) => {
			if (value) {
				if (Number(value) > Number((this.form.resourceAssets - this.form.depreciationReserves - this.salvage).toFixed(2))) {
					return callback(new Error('已大于原值-减值准备-预计残值'))
				}
			}
			callback();  _depreciationPeriod
		}
		const _depreciationPeriod = (rule, value,callback)=> {
      let reg = /^[0-9]*[1-9][0-9]*$/
			if (value) {
				if (value > this.form.expectYear) {
					return callback(new Error('已折旧期数不能大于预计使用期数'))
				}
        if (!reg.test(value)) {
          return callback(new Error('只能输入正整数'))
        }
			}
			callback();
		}
		const _depreciationReserves = (rule, value,callback)=> {
			if (value) {
				if (Number(value) > Number(this.form.resourceAssets)) {
					return callback(new Error('减值准备不能大于原值'))
				}
			}
			callback();
		}
		return {
			XG_voucherShow: false,  // 修改凭证弹框显示
			rows: '',  // 修改数据
			_monthdepreciation: 0, // 月折旧原值
      _beginningDepreciation: 0, // 期初累计折旧
			form: {
				cid: '',
				id: '',
				assetsCode: '',					// 资产编码
				assetsName: '',					// 资产编码
				assetsGenresId: '',				// 资产类别
				entryTime: '',					// 录入时间
				entryTimeStamp: '',				// 录入时间(时间戳)
				departName: '',					// 使用部门
				startUse: '',					// 开始日期
				clearPeriod: '',				// 清理期间
				zhejiuStyle: '1',				// 折旧方式
				expectYear: 0,					// 使用年限
				fixationSubjectId: '',			// 固定资产科目
				depreciationSubjectId: '',		// 累计折旧科目
				apportionSubjectId: '',			// 折旧费用科目
				paySubjectId: '',				// 支付方式科目
				resourceAssets: 0,			// 原值
				residualRatio: 0,			// 残值率
				depreciationReserves: 0,	// 减值准备
				beginningNetvalue: 0,		// 期初净值
				monthdepreciation: 0,		// 月折旧
				depreciationPeriod: 0,			// 已折旧期间
				beginningDepreciation: 0,	// 期初累计折旧
				salvage: 0,				// 预计残值
				remarks: '',					// 备注
				yearPeriods: '',				// 当前期
				adds: {							// 购买凭证
					name: '',
					id: ''
				},
			},
			options: {
				assetsGenres: [],				// 资产类别
				departName: [],					// 使用部门
				zhejiuStyle: [{					// 折旧方式
					label: '年限平均法',
					value: '1'
				},{
					label: '不提折旧',
					value: '5'
				}]
			},
			rulesForm: {
				assetsCode: [{
					required: true, message: '请输入资产编码'
				}],
				assetsName: [{
					required: true, message: '请输入资产名称'
				}],
				assetsGenresId: [{
					required: true, message: '请选择资产类别'
				}],
				departName: [{
					required: true, message: '请选择部门'
				}],
				startUse: [{
					required: true, message: '请选择开始日期'
				}],
				zhejiuStyle: [{
					required: true, message: '请选择折旧方式'
				}],
				expectYear: [{
					required: true, validator: expectYears
				}],
				fixationSubjectId: [{
					required: true, message: '请选择固定资产科目'
				}],
				depreciationSubjectId: [{
					required: true, message: '请选择累计折旧科目'
				}],
				apportionSubjectId: [{
					required: true, message: '请选择折旧费用科目'
				}],
				paySubjectId: [{
					required: true, message: '请选择支付方式科目'
				}],
				resourceAssets: [{
					required: true, validator: validateResourceAssets
				}],
				beginningDepreciation: [{
					required: false, validator: validateBeginningDepreciation
				}],
				depreciationReserves:[
					{required: true, validator: _depreciationReserves}
				],
				depreciationPeriod: [
					{required: true, validator: _depreciationPeriod}
				],
			},
			pickerOptions: {
				startUse: {
					disabledDate: (time) => {
						let currentDate = new Date(this.entryTime);
						let startVal = this.getAccountPeriod.startTimeStamp;
						currentDate = new Date(currentDate.getFullYear(), (currentDate.getMonth()+1), 0)

						if (currentDate) {
							//return time.getTime() > currentDate || time.getTime()<startVal;
							return time.getTime() > currentDate
						}
					}
				}
			},
			intSubjectVal: {
				zhejiuStyle: '1',
				fixationSubjectId: '',
				depreciationSubjectId: '',
				expectYear: 0
			},
			entryTime: '',						// 当前期（时间戳）
			currentMonth: '',					// 录入时间
			nowMonth: '',						// 现在选择开始日期
			isShowAddDepartmentDialog: false,	// 是否显示新增部门弹窗
			isRerequestDepartment: true,		// 是否重新请求部门
			isDisabled: false,					// 手动防止重复请求
			isButtonShow: true,
		}
	},
	computed: {
		// 显示弹窗
		isShow: {
			get () {
				return this.showVisible;
			},
			set (val) {
				this.$emit('update:showVisible', val);
			}
		},
		// 获取会计期间开始时间
		getAccountPeriod() {
			return this.$store.state.accountInfo.yearPeriods;
		},

		// 求残值（固定资产原值 * 残值率）
		salvage () {
			const val = (this.form.resourceAssets * this.form.residualRatio / 100).toFixed(2);
			this.$set(this.form, 'salvage', val)
			return val
		},
		// 求固定资产年折旧额（(固定资产原值 - 预计净残值) / 预计使用年限）
		yeardepreciation () {
			let val = ((this.form.resourceAssets - this.form.salvage) / (this.form.expectYear / 12)).toFixed(2)
			val = isNaN(val) || val == Infinity ? 0 : val;
			return val
		},
		// 求期初净值（原值-累计折旧-减值准备）
		beginningNetvalue () {
			let val = (this.form.resourceAssets - this.form.beginningDepreciation - this.form.depreciationReserves).toFixed(2)

			val = isNaN(val) || val == Infinity ? 0 : val;
			this.$set(this.form, 'beginningNetvalue', val)
			return val
		},
		// 是否可以编辑月折旧
		isEdit () {
			return this.form.zhejiuStyle == '5' ? true : false;
		},
		// 科目
		subjectData() {
			return this.$store.state.getSubjectId.SubjectList
		}
	},
	methods: {
		// 关闭弹框
		cancel(val){
			this.XG_voucherShow = val;
			this.$emit('onRefresh',true)
		},
		successEdit(val){//修改成功后的回调
			if(val){
				//this.reflashPage();
			}
		},
		// 点击购买凭证
		handleJump_PZ(row) {
			console.log(row)
			this.rows = row;
			this.XG_voucherShow = true;
		},
		// 获取会计期间/初始化数据
		getAccountPeriods() {
			if(!this.getAccountPeriod) {
				this.$store.dispatch('getAllYearPeriodsData')
			}
		},
		// 关闭新增弹窗
		handleIsShowAddDepartmentDialog(data) {
			this.isShowAddDepartmentDialog = data;
		},
		// 查询所有科目
		getSubject () {
			if (!this.subjectData) {
				this.$store.dispatch('getSubject')
			}
		},
		// 获取资产类别
		getAllAssets () {
			if (!this.options.assetsGenres.length) {
				this.$http.post('assets/allList',{}).then(res=>{
					this.options.assetsGenres = res.data.data;
				})
			}
		},
		// 获取部门
		getDepartment () {
			if (this.isRerequestDepartment) {
				this.$http.post('fixed/getauxiliaryAccounting',{}).then(res=>{
					this.options.departName = res.data.data;
				})

			}
		},
		// 获取折旧费用默认科目
		getDefaultSubject () {
			this.$http.post('fixed/getDefaultFixedassetsSubject' , {}).then(res=>{
				this.form = Object.assign({}, this.form, {
					assetsCode: res.data.data.assetsCode,
					apportionSubjectId: res.data.data.id,
					entryTime: res.data.data.entryTime,
					yearPeriods: this.$util.formatDate.format(res.data.data.entryTimeStamp, 'yyyyMM')

				})
				this.entryTime = res.data.data.entryTimeStamp;
			})
		},
		// 变更资产类别
		handlerAssetsNameChange (val) {
			if (val) {
				let data = this.options.assetsGenres.find(item => item.id == val);
				this.form = Object.assign({}, this.form, {
					zhejiuStyle: data.depreciationMethod,
					fixationSubjectId: data.assetsItemId,
					residualRatio: data.residualRatio,
					expectYear: data.estimateMonth || 0
				})
				this.form.depreciationSubjectId = data.depreciationItemId
			} else {
				this.form = Object.assign({}, this.form, this.intSubjectVal);
			}
      this.commonCalculation();
		},
		// 新增部门
		addDepartment () {
			this.isShowAddDepartmentDialog = true;
		},
		// 重新获取部门数据
		refreshDepartmentData (status) {
			if (status) {
				this.isRerequestDepartment = true;
				this.getDepartment();
			}
		},
		// 选择开始日期
		handlerStartUseChange (val) {
			this.currentMonth = this.$util.formatDate.format(this.entryTime, 'MM');
			let currentYear = this.$util.formatDate.format(this.entryTime, 'yyyy');
			this.nowMonth = this.$util.formatDate.format(val, 'MM');
			let nowYear = this.$util.formatDate.format(val, 'yyyy');
			if( currentYear + this.currentMonth == nowYear + this.nowMonth ) {
				this.isButtonShow = true;
			}else {
				this.isButtonShow = false;
			}
      // 计算已折旧期数  触发条件：选择完 开始日期后（当前期间-开始日期-1）
      const _nowData = new Date((nowYear +"-"+ this.nowMonth)).getTime();
      const _backData = new Date((currentYear +"-"+ this.currentMonth)).getTime();
      let diff = Math.floor((_backData - _nowData)/(1000*60*60*24*30)); // 相差月份
      this.form.depreciationPeriod = Number((diff - 1) > 0?diff - 1:0);  // 计算已折旧期数
      /* 触发计算期初累计折旧、期初净值 */
      this.form.beginningDepreciation = this.form.depreciationPeriod * (this._monthdepreciation || 0);
		},
		// 设置折旧费用默认科目
		setDefault (id) {
			if(!id) {
				return this.$message.warning('请选择一个科目！')
			}
			const data = this.subjectData.find(item => item.id === id);
			try {
				this.$confirm(`确定设置“${data.code} - ${data.name}”为折旧费用默认科目吗？`, '提示', {
					type: 'warning',
					closeOnClickModal: false
				}).then(()=>{
					this.$http.post('fixed/addDefault' , { subjectId: this.form.apportionSubjectId}).then(res=>{
						if(res&&res.data.code==1) {
							this.$message.success('设置成功!')
						}
					})
				})
			} catch (e) {

			}

		},
		// 获取焦点时选中数据
		handleEditField (e) {
			const input = e.target;
			input.select();
		},
		// 失去焦点
		handleCancelEdit (e, name) {
			let value = e.target.value;
			if(name == "residualRatio") { // 残值率不能大于100
				if(value < 0) value = 0;
				if(value > 100) value = 100;
			}
			if(name == "beginningDepreciation" && value < 0) { // 期初累计折旧
				value = 0;
			}
			if (name !== 'depreciationPeriod') {
				value = (value !== '' && !isNaN(value) && value != '.') ? parseFloat(value).toFixed(2) : this[name] || 0;
			} else {
				value = (value !== '' && !isNaN(value)) ? Number(value) : 0;
			}

			this.$set(this.form, name, Math.abs(value));
      console.log(name);
      // 如果输入的是月折旧
      if(name == "monthdepreciation") {
         this._monthdepreciation = this.form.monthdepreciation;
      }
      // 如果输入的是期初累计折旧
      if(name == "beginningDepreciation") {
        this._beginningDepreciation = this.form.beginningDepreciation;
         // 计算月折旧 =（原值-减值准备-预计残值-期初累计折旧）/(预计使用期数-已折旧期数)
        let _monthdepreciation = (this.form.resourceAssets - this.form.depreciationReserves - this.salvage - (this._beginningDepreciation || 0))/(this.form.expectYear - this.form.depreciationPeriod)
        if(_monthdepreciation === Infinity) _monthdepreciation = 0;
        this._monthdepreciation = _monthdepreciation;
        this.form.monthdepreciation = this.formartNum(_monthdepreciation);
     }
      // 如果输入的是已折旧期数 && 原值
      if(name == "depreciationPeriod" || name == "resourceAssets" || name == "residualRatio" || name == "depreciationReserves") {
        this.commonCalculation();
      }
		},
    // 计算月折旧和期初累计折旧
    commonCalculation() {
        // 计算月折旧 （原值-减值准备-预计残值）/预计使用期数
        let _monthdepreciation = (this.form.resourceAssets - this.form.depreciationReserves - this.salvage)/this.form.expectYear
        if(_monthdepreciation === Infinity) _monthdepreciation = 0;
        this._monthdepreciation = _monthdepreciation;
        this.form.monthdepreciation = this.formartNum(_monthdepreciation);
        // 期初累计折旧=已折旧期数乘以月折旧
          let val = this._monthdepreciation * this.form.depreciationPeriod;
          this._beginningDepreciation = val;
          this.form.beginningDepreciation = this.formartNum(val)
    },
    // 格式化NUmber
    formartNum(val) {
      if(val === Infinity) val=0;
      val = isNaN(val) ? 0 : Number(val.toFixed(2));
      return val;
    },
		// 确定保存
		async confirm (formName, status) {
			try {
				let valid = await this.$refs[formName].validate();

				if (valid) {
					this.form.startUse = this.$util.formatDate.format(this.form.startUse, 'yyyy-MM-dd');
					this.form.adds.name = status == 1 ? 'add' : '';
					this.isDisabled = true;
          this.form.preciseMonthDep = this._monthdepreciation; // 赋值月折旧精度
					let res = await this.$http.post('fixed/save',this.form)
					try {
						if (res.data.code == 1) {
							this.$message({
								type: 'success',
								message: res.data.msg,
								showClose: true
							});
							this.$emit('onRefresh', true);
							this.isShow = false;
						} else {
							this.$set(this.form.adds, 'name', this.nowMonth == this.currentMonth ? 'add' : '');
						}
					} finally {
						this.isDisabled = false;
					}
				}
			} catch(e) {

			}
		},
	},
	created () {
		this.getAccountPeriods();
	},
	mounted() {

	},
	watch: {
		tableData(val) {
			if(!val) {
				this.form.adds = {							// 购买凭证
					name: '',
					id: ''
				}
			}
		},
		// 弹窗显示时调用
		showVisible (val) {
			if (val) {
				if (this.assetForm.status == 'add') {
					this.$nextTick(() => {
						this.form = Object.assign({}, this.form, this.assetForm.data);

						this.getDefaultSubject();	// 获取折旧费用默认科目
					})
				} else {
					this.$nextTick(() => {
						this.$refs.form.resetFields();
						for (const i in this.form) {
							for (const k in this.assetForm.data) {
								if ( i == k ) {
									this.$set(this.form, i, this.assetForm.data[i]);
								}
							}
						}
						this.entryTime = this.form.entryTimeStamp;
					})
				}
				Promise.all([this.getSubject(), this.getAllAssets(), this.getDepartment()])
			} else {
				setTimeout(() => {
					this.$refs.form.resetFields();
				}, 500)
			}
		},
	}
}
</script>
<style lang='less'>
	#dialog-assets {
		.asset-dialog {
			.el-dialog {
				width: 624px;
			}
			.h5 {
				color: #333;
				font-weight: 700;
				margin-bottom: 20px;
			}
			.select-subject {
				display: inline-block;
			}
			.el-date-editor.el-input, .el-date-editor.el-input__inner {
				width: 172px;
			}
			.departName-input, .subjectSelect {
				width: 135px;
			}
			.apportionSubject .subjectSelect {
				width: 98px;
			}
			a {
				cursor: pointer;
				color: #448ce0;
			}
			.setDefault {
				margin-left: 5px;
				&:hover {
					text-decoration: underline;
				}
			}
			.expectYear, .residualRatio {
				.el-input {
					width: 148px;
				}
				span {
					margin-left: 5px;
				}
			}
			.isTextred {
				color:red;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/assets.vue